const distanceInMiles = 1.609344;
export default km => km / distanceInMiles;
